import { createSelector } from "@reduxjs/toolkit";

import { RootState } from "types";
import { initialState } from ".";

const selectSlice = (state: RootState) => state.global || initialState;

export const selectGlobal = createSelector([selectSlice], (state) => state);
export const selectPlanData = createSelector(
	[selectSlice],
	(state) => state.planData
);
export const selectCheckAvailabilityDetails = createSelector(
	[selectSlice],
	(state) => state.checkAvailabilityDetails
);
export const selectLines = createSelector(
	[selectSlice],
	(state) => state.lines
);
export const selectCompatibility = createSelector(
	[selectSlice],
	(state) => state.compatibilityData
);
export const selectCompatibilities = createSelector(
	[selectSlice],
	(state) => state.compatibilitiesData
);
export const selectUser = createSelector([selectSlice], (state) => state.user);
export const selectIsPorting = createSelector(
	[selectSlice],
	(state) => state.isPorting
);
export const selectAddLinesData = createSelector(
	[selectSlice],
	(state) => state.addLinesData
);
export const selectPortRequestSubmitted = createSelector(
	[selectSlice],
	(state) => state.portRequestSubmitted
);
export const selectSingleNetworkDevice = createSelector(
	[selectSlice],
	(state) => state.singleNetworkDevice
);
